export default __webpack_public_path__ + "static/media/example_img_1_5.5a7412fc.png";